import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import linkedin from "../images/linkedin.svg";
import facebook from "../images/facebook.svg";
import teqnodux from "../images/clients/teqnodux icone.png";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">
          {/* Top area: Blocks */}
          <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">
            {/* 1st block */}
            <div className="col-span-12 lg:col-span-4">
              <div className="box-border border-b-4 border-[#377c7d] p-6 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                {/* Logo Image */}
                <img
                  src={teqnodux} // Replace 'logoPath' with the actual path to your logo image
                  alt="TeqnoDux Logo"
                  className="w-24 h-auto mx-auto mb-4" // Adjust size and centering
                />

                {/* Address Section */}
                <div className="text-md font-medium text-gray-600 text-center">
                  <h5>B-705/706 IT Park,</h5>
                  <p>Mota varachha,</p>
                  <p>Surat, Gujarat,</p>
                  <p>India (394101)</p>
                </div>
              </div>
            </div>

            {/* 2nd block */}
            <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
              <h6 className="text-[#377c7d] text-xl font-bold mb-4">LINKS</h6>
              <ul className="text-md">
                <li className="mb-2">
                  <HashLink
                    to="/#about"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                  >
                    About
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/#services"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                  >
                    Services
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/#technologies"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                  >
                    Technologies
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="https://teqnodux.com/showcase/"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                    target="_blank"
                  >
                    Portfolio
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/career#career"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                  >
                    Career
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/blogs#blogs"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                  >
                    Blogs
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/contact#contact"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                  >
                    Contact
                  </HashLink>
                </li>
              </ul>
            </div>

            {/* 3rd block */}
            <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
              <h6 className="text-[#377c7d] text-xl font-bold mb-4">
                OUR SERVICES
              </h6>
              <ul className="text-md">
                <li className="mb-2">
                  <HashLink
                    to="/#services"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wide transition duration-250 ease-in-out"
                  >
                    Web Development
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/#services"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-normal transition duration-250 ease-in-out"
                  >
                    Mobile App Development
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/#services"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wide transition duration-250 ease-in-out"
                  >
                    CRM Consulting
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/#services"
                    className="text-[#377c7d] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                  >
                    3D on the Web
                  </HashLink>
                </li>
              </ul>
            </div>

            {/* 4th block */}
            <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-[#377c7d]">
              <div className="text-xl mb-6">Social Media Links.</div>

              <div className="text-md font-medium mb-6">
                Follow us on social media.
              </div>
              <div className="mx-auto text-center mt-2">
                <ul className="flex justify-center mb-4 md:mb-0">
                  <li>
                    <a
                      href="https://www.linkedin.com/company/teqnodux/posts/?feedView=all"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex justify-center items-center text-[#377c7d] hover:text-gray-500 bg-white hover:bg-gray-100 rounded-full shadow transition duration-150 ease-in-out p-1"
                      aria-label="Twitter"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        className="fill-current font-black hover:animate-pulse"
                      >
                        <circle cx="4.983" cy="5.009" r="2.188"></circle>
                        <path d="M9.237 8.855v12.139h3.769v-6.003c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.811 1.961 3.218v5.904H21v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.237zm-6.142 0H6.87v12.139H3.095z"></path>
                      </svg>
                    </a>
                  </li>

                  <li className="ml-4">
                    <a
                      href="https://www.facebook.com/teqnoDux/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex justify-center items-center text-[#377c7d] hover:text-gray-500 bg-white hover:bg-gray-100 rounded-full shadow transition duration-150 ease-in-out p-1"
                      aria-label="Facebook"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        className="fill-current font-black hover:animate-pulse"
                      >
                        <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"></path>
                      </svg>
                    </a>
                  </li>
                  <li className="ml-4">
                    <a
                      href="mailto:info@teqnodux.com"
                      className="flex justify-center items-center text-[#377c7d] hover:text-gray-500 bg-white hover:bg-gray-100 rounded-full shadow transition duration-150 ease-in-out p-1"
                      aria-label="Email"
                    >
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        className=" font-black hover:animate-pulse"
                        fill="none"
                      >
                        <path
                          d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7"
                          stroke="#377c7d"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <rect
                          x="3"
                          y="5"
                          width="18"
                          height="14"
                          rx="2"
                          stroke="#377c7d"
                          stroke-width="3"
                          stroke-linecap="round"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
              <div className="text-sm text-gray-200 font-semibold py-1">
                Copyright &copy; {new Date().getFullYear()}
                {"  "}
                <HashLink to="#" className=" hover:text-gray-900">
                  TeqnoDux
                </HashLink>
                . All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
